<nav role="navigation">
    <!-- the inline-block class is to make sure that ul is not 100% wide (for off click in icms) -->
    <ul class="flex flex-middle"
        (offClick)="closeMeganav()"
        [offClickFilter]="'page-header-meganav-content-item'">
        @if (content?.shopSubmenu?.length) {
        <li (click)="onClick(shopSubmenuToggleGroupId,0)">
            <div class="p2 col-1 _link"
                 [toggleClass]="'is-active'"
                 [toggleClassBy]="[shopSubmenuToggleGroupId, 0]"
                 (mouseenter)="onMouseIn(0, true)"
                 (mouseleave)="onMouseOut(0, true)">
                <div class="flex flex-middle cursor-pointer">
                    @if (content.shopSubmenuIcon) {
                    <i [class]="content.shopSubmenuIcon"
                       class="m-r-1"></i>
                    }
                    <p class="_tab-label"
                       [attr.data-text]="'Shop All' | translate">{{'Shop All' | translate}}</p>
                </div>
            </div>
        </li>
        }
        @for (item of items; track $index) {
        @if (item.type !== 'divider') {
        @let columnsCount = item.columns?.length || 0;
        @let brandItemsCount = item.brandItems?.length || 0;
        @let hasSubmenu = columnsCount > 0 || brandItemsCount > 0;
        <li
            [class]="(!hasSubmenu && item.meganavItemBackground) ? item.meganavItemBackground + ' p-t-1 p-b-1 p-l-2 p-r-2 b-radius-4' : !hasSubmenu ? '_link-underlined' : ''">
            <href (click)="onClick(toggleGroupId, $index)"
                  [link]="item.link"
                  cy-navigationlink>
                <div (mouseenter)="hasSubmenu && onMouseIn($index)"
                     (mouseleave)="hasSubmenu && onMouseOut($index)">
                    <div class="p2"
                         [class]="(!hasSubmenu && item.meganavItemColor) || 'col-1 _link'"
                         [toggleClass]="'is-active'"
                         [toggleClassBy]="[toggleGroupId, $index]">
                        <div class="flex flex-middle">
                            @if (item?.meganavItemIcon) {
                            <i [class]="item?.meganavItemIcon"
                               class="m-r-1"></i>
                            }
                            <div class="_tab-label"
                                 [attr.data-text]="item.text"
                                 [class.fw-bold]="item.bold"
                                 *iCms="'text' of item"></div>
                        </div>
                    </div>
                </div>
            </href>
        </li>
        } @else {
        <li [class]="item.divider === 'line' ? '_divider-line' : 'flex-grow'"></li>
        }
        }
    </ul>
</nav>